class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
 
    document.body.classList.add('overflow-hidden');
    this.mbLockScroll();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    this.mbUnlockScroll();
  }

  // Phones: body overflow:hidden alone does not stop the page behind the drawer from scrolling
  // (iOS Safari / Chrome Android), so pin the page in place while the drawer is open.
  mbLockScroll() {
    if (window.innerWidth >= 750 || document.body.dataset.mbLocked) return;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.dataset.mbLocked = '1';
    document.body.dataset.mbScrollY = String(y);
    var st = document.body.style;
    st.position = 'fixed';
    st.top = '-' + y + 'px';
    st.left = '0';
    st.right = '0';
    st.width = '100%';
  }

  mbUnlockScroll() {
    if (!document.body.dataset.mbLocked) return;
    var y = parseInt(document.body.dataset.mbScrollY || '0', 10) || 0;
    var st = document.body.style;
    st.position = '';
    st.top = '';
    st.left = '';
    st.right = '';
    st.width = '';
    delete document.body.dataset.mbLocked;
    delete document.body.dataset.mbScrollY;
    window.scrollTo(0, y);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* "You May Also Like" cards: when another option is chosen, show that variant's photo. */
(function () {
  if (window.__mbUpgradeImg) return;
  window.__mbUpgradeImg = true;
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest ? e.target.closest('.upgrade-opt') : null;
    if (!sel) return;
    var card = sel.closest('.upgrade-product-card');
    if (!card || !card.dataset.variants) return;
    // wait one tick so the price/option logic has finished adjusting the selects
    setTimeout(function () {
      var variants;
      try { variants = JSON.parse(card.dataset.variants); } catch (err) { return; }
      var wanted = Array.prototype.map.call(card.querySelectorAll('.upgrade-opt'), function (s) { return s.value; });
      var v = variants.find(function (x) { return wanted.every(function (val, i) { return x.o[i] === val; }); });
      if (!v || !v.i) return;
      var img = card.querySelector('.upgrade-product-image img');
      if (img && img.getAttribute('src') !== v.i) {
        img.removeAttribute('srcset');
        img.src = v.i;
      }
    }, 0);
  });
})();

/* "Shop by price" tiles: show and filter in the visitor's own currency (e.g. UK sees pounds). */
(function () {
  var cur = (window.Shopify && window.Shopify.currency) || {};
  var rate = parseFloat(cur.rate);
  var active = cur.active;
  if (!active || active === 'USD' || !(rate > 0)) return;
  function nice(n) {
    var v = n * rate;
    var step = v >= 1000 ? 100 : v >= 100 ? 10 : 5;
    return Math.max(step, Math.round(v / step) * step);
  }
  var fmt;
  try {
    fmt = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: active, minimumFractionDigits: 0, maximumFractionDigits: 0 });
  } catch (err) { return; }
  function run() {
    document.querySelectorAll('.collection-list-wrapper a[href*="filter.v.price"]').forEach(function (a) {
      a.setAttribute('href', a.getAttribute('href').replace(/(filter\.v\.price\.(?:gte|lte)=)(\d+(?:\.\d+)?)/g, function (m, p, n) {
        return parseFloat(n) === 0 ? m : p + nice(parseFloat(n));
      }));
    });
    document.querySelectorAll('.collection-list-wrapper .card__heading').forEach(function (h) {
      var walker = document.createTreeWalker(h, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = walker.nextNode())) {
        if (n.nodeValue.indexOf('$') === -1) continue;
        n.nodeValue = n.nodeValue.replace(/\$(\d+(?:\.\d+)?)/g, function (m, d) { return fmt.format(nice(parseFloat(d))); });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
